import { StyledInput, StyledLabel } from './MultiCheckbox.styles';
import { IMultiCheckbox } from './MultiCheckbox.types';

const MultiCheckbox = ({
  options,
  activeOptions,
  onChange,
  user = 'landlord',
}: IMultiCheckbox): JSX.Element => {
  const handleOnChange = (newActiveOptions: string[]) => {
    onChange(newActiveOptions);
  };

  return (
    <>
      {options.map((option, index) => {
        return (
          <div key={index}>
            <StyledInput
              id={option.name}
              type="checkbox"
              checked={activeOptions?.includes(option.name)}
              onChange={handleOnChange.bind(
                null,
                activeOptions?.includes(option.name)
                  ? activeOptions.filter(val => val !== option.name)
                  : [...activeOptions, option.name],
              )}
              user={user}
            />
            <StyledLabel htmlFor={option.name}>{option.label}</StyledLabel>
          </div>
        );
      })}
    </>
  );
};

export default MultiCheckbox;
